import StatusTab from './StatusTab';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import {
  statusDataSel,
  returnIsPendingSel,
  returnsActions,
  returnStatusAlertSel,
  returnIsDownloadingPdfSel
} from 'src/store/modules/returns';

const mapStateToProps = (state: IInitialState) => ({
  statusData: statusDataSel(state),
  isPending: returnIsPendingSel(state),
  returnStatusAlert: returnStatusAlertSel(state),
  isDownloadingPdf: returnIsDownloadingPdfSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  closeAlert: () => {
    dispatch(
      returnsActions.setReturnStatusAlert({
        show: false,
        message: '',
        type: '',
        icon: ''
      })
    );
  },
  downloadPdf: (rmaNumber: string, isPrepaidLabel: string) => {
    dispatch(returnsActions.downloadPdf(rmaNumber,isPrepaidLabel));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusTab);
